import React from 'react'
import styled from 'styled-components'
import { formatCurrency } from '@utils'

interface Props {
  amount: number
}

export const HolviPaymentButton: React.FC<Props> = ({ amount }) => {
  return (
    <StyledButton>
      <StyledLabel>
        <span>{`Pay`}</span>
        <span className="amount">{formatCurrency(amount)}</span>
      </StyledLabel>
    </StyledButton>
  )
}

const StyledButton = styled.button`
  padding: ${({ theme }) => theme.spacing.xs}rem ${({ theme }) => theme.spacing.sm}rem;
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.lg}rem;
  outline: none;
  font-weight: 500;
  background-color: ${({ theme }) => theme.colors.warning};
  color: ${({ theme }) => theme.colors.neutralBlack};
  outline: 2px solid ${({ theme }) => theme.colors.warning}55;
  border: none;

  & > img {
    height: ${({ theme }) => theme.iconSize.xxs}rem;
  }
`

const StyledLabel = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  align-items: center;

  .amount {
    font-size: ${({ theme }) => theme.fontSize.md}rem;
  }
`
